import React, { useEffect, useState } from 'react';
import config from '../coreFIles/config';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import { getTieredGrouplistAction, getSearchSuburbAction, gettemproductAction, savequotationAction, getSelectedQuoteProductAction,getQuoteShippingCostAction  } from '../Action/action';
import Cookies from "js-cookie";
const loginData = (!Cookies.get('loginSuccessfastenerwarehouseAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessfastenerwarehouseAdmin'));
const Addquotes = () => {
    if (!loginData || loginData == '') {
        window.location.href = `${config.baseUrl}`;
    }
    if(loginData.role != config.role_admin){
    window.location.href = `dashboard`;	
    }
    const [quotesForm, setQuotesForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company_name: '',
    tiered_id: '',       
    shipping: '',
    required_shipping: 1,
    address: '',
    suburb: '',
    state: '',
    postcode: '',
    country: 'AU',       
    quotesProducts: [],
	custom_products: []
    });

    const [validationError, setValidationError] = useState({});
    const [tiered_group, settiered_group] = useState([]);
    const [searchProduct, setsearchProduct] = useState([]);
    const [spinloader, setspinloader] = useState('0');
    const [shiploader, setshiploader] = useState('0');
    
    const [suburb, setsuburb] 					= useState('');
    const [postcode, setpostcode] 				= useState('');
    const [SuburbsearchResults, setSuburbsearchResults] 	= useState([]);

    useEffect(() => {
    getTieredGroupAPI();
    }, []);

    const handleKeyPress = (e) => {
    const isValidInput = /^[0-9\b]+$/.test(e.key);
    if (!isValidInput) {
    e.preventDefault();
    }
    };

    const handlePriceKeyPress = (e) => {
    const isValidInput = /^[0-9.\b]$/.test(e.key);
    if (!isValidInput) {
    e.preventDefault();
    }
    };    

    const inputHandler = (e) => {
    const { name, value } = e.target;
    setQuotesForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleProductSelect = async (row) => {
		const { description, sell_quantity_minimum,id,price_per,hobson_part,sell_quantity_increment } = row;
		const res = await getSelectedQuoteProductAction({product:row,tiered_id : quotesForm.tiered_id});
		if (res.success) {
			let data = res.data;
			setQuotesForm((prevForm) => ({
				...prevForm,
				quotesProducts: [
					...prevForm.quotesProducts,
					{ description, sell_quantity_minimum,id,price_per,hobson_part,sell_quantity_increment,SinglePrice:data.SinglePrice, pPrice:data.pPrice, custom_price: '' }
					]
			}));
		}
		setsearchProduct([]);
	};

    const getTieredGroupAPI = async () => {
		try {
			const res = await getTieredGrouplistAction();
			settiered_group(res.success ? res.data : []);
		} catch (error) {
			console.error('Error fetching tiered groups:', error);
			toast.error("Failed to fetch tiered groups.");
			settiered_group([]);
		}
    };

    const searchtempproduct = async (str) => {
		if (str !== '') {
			const res = await gettemproductAction({ str });
		if (res.success) {
			setsearchProduct(res.data);
			console.log(res.data)
		} else {
			setsearchProduct([]);
		}
		} else {
			setsearchProduct([]);
		}
    };

    const validateForm = () => {
		const errors = {};
		if (!quotesForm.first_name) errors.first_nameError = "Please enter first name.";
		if (!quotesForm.last_name) errors.last_nameError = "Please enter last name.";
		if (!quotesForm.email) errors.emailError = "Please enter email.";
		if (!quotesForm.phone) errors.phoneError = "Please enter phone number.";
		if (!quotesForm.company_name) errors.company_nameError = "Please enter company name.";
		if (!quotesForm.tiered_id) errors.tiered_idError = "Tiered group is required.";
		if (!quotesForm.quotesProducts.length) errors.quotesProductsError = 'Please select at least one product.';
		
		if (quotesForm.custom_products.length) {
			quotesForm.custom_products.forEach((product, index) => {
				if (!product.product_description) errors[`customProduct_${index}_description`] = 'Product description is required.';
				if (!product.product_quantity || product.product_quantity <= 0) errors[`customProduct_${index}_quantity`] = 'Product quantity must be greater than 0.';
				if (!product.product_sku) errors[`customProduct_${index}_sku`] = 'Product SKU is required.';
				if (!product.custom_price) errors[`customProduct_${index}_customPrice`] = 'Custom price is required.';
			});
		}

		setValidationError(errors);
		return Object.keys(errors).length <= 0;
    };

    const removetemproduct = (index) => {
		setQuotesForm((prevForm) => ({
			...prevForm,
			quotesProducts: prevForm.quotesProducts.filter((_, i) => i !== index)
		}));
    };

    const SearchSuburb = async (str) => {
		try {
			setsuburb(str);
			setpostcode('');
			setQuotesForm((old) => {
			return { ...old, 'suburb': '' };
			});
			setQuotesForm((old) => {
			return { ...old, 'postcode': '' };
			});
			setQuotesForm((old) => {
			return { ...old, 'state': '' };
			});
			let res = await getSearchSuburbAction({str:str});
			setSuburbsearchResults(res.data);
		}catch (error) {
			console.error(error);
		}
    };

    const handleSelectSuburb = async (row) => {
		console.log(row)
		setsuburb(row.suburb);
		setpostcode(row.postcode);
		setQuotesForm((old) => {
			return { ...old, 'suburb': row.suburb };
		});
		setQuotesForm((old) => {
			return { ...old, 'postcode': row.postcode };
		});
		setQuotesForm((old) => {
			return { ...old, 'state': row.state };
		});

		setSuburbsearchResults({});       

    };	

    const calculateShipping = async () => {
        if (quotesForm.quotesProducts.length === 0) {
         toast.error('Please add at least one product first');
            return;
        }

        if (!quotesForm.suburb || !quotesForm.postcode || !quotesForm.state) {
          toast.error('Please select a valid suburb first');
            return;
        }

        try {
            setshiploader(1);
        const shippingData = await getQuoteShippingCostAction({ 
			QuoteDetails: quotesForm, Quote_id:0  });

        if (shippingData.success) {
            setQuotesForm(prev => ({
            ...prev,
            shipping: shippingData.data
        }));
         toast.success('Shipping cost calculated successfully');
        } else {
            toast.error('Unable to calculate shipping cost');
        }
        } catch (error) {
            console.error('Error calculating shipping:', error);
            toast.error('Error calculating shipping cost');
        } finally {
            setshiploader(0);
        }
    };


    const submitForm = async (e) => {
        e.preventDefault();
        const isValid = validateForm();
            if (!isValid) {
        }
        else{
            setspinloader(1);
            let res = await savequotationAction({...quotesForm})
            if(res.success){
                toast.success(res.msg)
                setTimeout(() => {
                 window.location.href = `${config.baseUrl}quotes`;
                 }, 1200);
        }
        else{
            setspinloader(0);
            toast.error(res.msg)
        }
        }
    };

    // for handling product quantity change
    const handleProductQuantityChange = async (e, index) => {      
		let newQuantity = e.target.value;
		// Allow typing - keep as string during input, only parse on blur
		// Only update the specific item at this index
		setQuotesForm((prevForm) => {
			const updatedProducts = [...prevForm.quotesProducts];
			if (updatedProducts[index]) {
				updatedProducts[index] = { 
					...updatedProducts[index], 
					sell_quantity_minimum: newQuantity === '' ? '' : newQuantity
				};
			}
			return {
				...prevForm,
				quotesProducts: updatedProducts
			};
		});
    };

    const handleQuantityChangeManual = (e, row, action, index) => {       
		// Get current quantity from state to avoid stale data
		setQuotesForm((prevForm) => {
			const updatedProducts = [...prevForm.quotesProducts];
			if (!updatedProducts[index]) {
				return prevForm;
			}
			
			const currentProduct = updatedProducts[index];
			const quantityBreak = currentProduct.sell_quantity_increment || row.sell_quantity_increment;
			const currentQuantity = typeof currentProduct.sell_quantity_minimum === 'string' 
				? parseInt(currentProduct.sell_quantity_minimum) || 0 
				: currentProduct.sell_quantity_minimum || 0;
			
			let updatedQuantity;
			if(action == "inc") {
				updatedQuantity = currentQuantity + quantityBreak;
			} else if(action == "dec"){
				updatedQuantity = currentQuantity - quantityBreak;
				if(updatedQuantity <= 0){
					return prevForm; // Don't update if result would be <= 0
				}
			} else {
				return prevForm;
			}
			
			// Only update the specific item at this index
			updatedProducts[index] = { 
				...currentProduct, 
				sell_quantity_minimum: updatedQuantity 
			};
			
			return {
				...prevForm,
				quotesProducts: updatedProducts
			};
		});
	};

    const updateProductQuantity = async (e, row, index) => {
		let enteredQuantity = e.target.value;
		// Get quantityBreak from state to ensure we have latest data
		setQuotesForm((prevForm) => {
			const updatedProducts = [...prevForm.quotesProducts];
			if (!updatedProducts[index]) {
				return prevForm;
			}
			
			const currentProduct = updatedProducts[index];
			const quantityBreak = currentProduct.sell_quantity_increment || row.sell_quantity_increment;
			
			// Parse to number for calculation
			let parsedQuantity = enteredQuantity === '' ? 0 : parseInt(enteredQuantity, 10);
			if (isNaN(parsedQuantity) || parsedQuantity < 0) {
				parsedQuantity = 0;
			}
			
			let updatedQuantity;
			if(parsedQuantity == 0){
				updatedQuantity = quantityBreak;
			}else{
				updatedQuantity = Math.ceil(parsedQuantity / quantityBreak) * quantityBreak;
			}
			
			// Only update the specific item at this index
			updatedProducts[index] = { 
				...currentProduct, 
				sell_quantity_minimum: updatedQuantity 
			};
			
			return {
				...prevForm,
				quotesProducts: updatedProducts
			};
		});
	};

    const handlePriceChange = (e, row, index) => {
		const newPrice = e.target.value;
		const sanitizedValue = newPrice.replace(/[^0-9.]/g, '');
		const decimalParts = sanitizedValue.split('.');
		const cleanedValue = decimalParts.length > 2 ? `${decimalParts[0]}.${decimalParts[1]}` : sanitizedValue;
		// Only update the specific item at this index
		setQuotesForm((prevForm) => {
			const updatedProducts = [...prevForm.quotesProducts];
			if (updatedProducts[index]) {
				updatedProducts[index] = { 
					...updatedProducts[index], 
					custom_price: cleanedValue === '' ? '' : cleanedValue 
				};
			}
			return {
				...prevForm,
				quotesProducts: updatedProducts
			};
		});
	};

    const updateProductQuantityOnEnter = async (e,row,index) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			let enteredQuantity = e.target.value;
			// Get quantityBreak from state to ensure we have latest data
			setQuotesForm((prevForm) => {
				const updatedProducts = [...prevForm.quotesProducts];
				if (!updatedProducts[index]) {
					return prevForm;
				}
				
				const currentProduct = updatedProducts[index];
				const quantityBreak = currentProduct.sell_quantity_increment || row.sell_quantity_increment;
				
				// Parse to number for calculation
				let parsedQuantity = enteredQuantity === '' ? 0 : parseInt(enteredQuantity, 10);
				if (isNaN(parsedQuantity) || parsedQuantity < 0) {
					parsedQuantity = 0;
				}
				
				let updatedQuantity;
				if(parsedQuantity == 0){
					updatedQuantity = quantityBreak;
				}else{
					updatedQuantity = Math.ceil(parsedQuantity / quantityBreak) * quantityBreak;
				}
				
				// Only update the specific item at this index
				updatedProducts[index] = { 
					...currentProduct, 
					sell_quantity_minimum: updatedQuantity 
				};
				
				return {
					...prevForm,
					quotesProducts: updatedProducts
				};
			});
		}
	};


	
	const handleCustomProductSelect = async () => {  
		
		
		let product_id = 1;
		
		// Ensure uniqueness
		while (quotesForm.custom_products.some(p => p.product_id === product_id)) {
			product_id++;
		}
		
		console.log(quotesForm.custom_products);
		
		setQuotesForm((prevForm) => ({
			...prevForm,
			custom_products: [
				...prevForm.custom_products,
				{ 
					product_description: '', 
					product_quantity: 1,
					product_id: product_id,
					price_per: '',
					product_sku: '',
					sell_quantity_increment: 1,
					SinglePrice: '', 
					custom_price: '' 
				}
			]
		}));
                
	};
    
   
    // for handling product quantity change Custom
    const handleCustomProductQuantityChange = async (e,row,product_id) => {
      
        let newQuantity = parseInt(e.target.value);
        if(newQuantity > 0){}else {newQuantity=0;}        
        setQuotesForm((prevForm) => ({
            ...prevForm,
            custom_products: prevForm.custom_products.map((product) =>
                  product.product_id === product_id
                    ? { ...product, product_quantity: newQuantity }
                    : product
            ),
        }));

    };
  
    const handleQuantityChangeManualCustom = (e, row,action) => {
        let enteredQuantity = parseInt(e.target.value,10);
        if (isNaN(enteredQuantity) || enteredQuantity < 0) {
            enteredQuantity = 0;
        }    
        let product_id = row.product_id;
        const quantityBreak = row.sell_quantity_increment;
    
        var updatedQuantity ;
        const currentQuantity = row.product_quantity || 0; 
        if(action == "inc") {
            
         updatedQuantity = currentQuantity + quantityBreak;
        }
        if(action == "dec"){
            if(currentQuantity <= 0){
                return currentQuantity
            }

            updatedQuantity = currentQuantity - quantityBreak;
        }
        setQuotesForm((prevForm) => ({
            ...prevForm,
            custom_products: prevForm.custom_products.map((product) =>
                product.product_id === product_id
                    ? { ...product, product_quantity: updatedQuantity }
                    : product
            ),
        }));
    };
    
    
     const handleInputChangeCustomProduct = (e, row) => {
		 const { name, value } = e.target;
		 console.log(value);
				
		setQuotesForm((prevForm) => ({
			...prevForm,
			custom_products: prevForm.custom_products.map((product) =>
				product.product_id === row.product_id
					? { ...product, [name]: value }
					: product
			),
		}));
		
        
		
	};

    
    const CartRemoveCustomProduct = async (product_id) => {
       
       setQuotesForm((prevForm) => ({
			...prevForm,
			custom_products: prevForm.custom_products.filter(product => product.product_id !== product_id)
		}));
           
    };
   
   	const handleincludeshipping = async (required_shipping) => {
        setQuotesForm((old) => {
			return { ...old, 'required_shipping': required_shipping };
		});
	};	
		
		
		

    return (
        <>
            <Sidebar />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Toaster />
                <Header />
                <div className="container-lg mb-4">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item">
                                <Link className="homelink" to={`${config.baseUrl}`}>Home</Link>
                            </li>
                            <li className="breadcrumb-item active"><span>Create quotes</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="body flex-grow-1 px-3">
                    <div className="container-lg">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card mb-4">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col-md-6 text-start">
                                                <span>Create quotes</span>
                                            </div>
                                            <div className="col-md-6 text-end">
                                                <Link className="btn btn-primary editbtn text-white" to={`${config.baseUrl}quotes`}>Back</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body inner-body">
                                        <form className="row g-3" onSubmit={submitForm}>
                                        <div className="col-md-4">
                                                <label className="form-label" htmlFor="tiered_id">Tiered group<span className="req-star">*</span></label>
                                                <select className={validationError.tiered_idError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="tiered_id" name="tiered_id" onChange={inputHandler} value={quotesForm.tiered_id}>
															<option value="">Select tiered group</option>
															{tiered_group.length > 0 ? (
																tiered_group.map((tg) => (
																	<option key={tg.id} value={tg.id}>{tg.title}</option>
																))
															) : null}
														</select>
                                                <div className="invalid-feedback">{validationError.tiered_groupError}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="first_name">First name<span className="req-star">*</span></label>
                                                <input className={validationError.first_nameError ? 'form-control is-invalid' : 'form-control'} id="first_name" name="first_name" placeholder="Enter first name" type="text" onChange={inputHandler} value={quotesForm.first_name} />
                                                <div className="invalid-feedback">{validationError.first_nameError}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="last_name">Last name<span className="req-star">*</span></label>
                                                <input className={validationError.last_nameError ? 'form-control is-invalid' : 'form-control'} id="last_name" name="last_name" placeholder="Enter last name" type="text" onChange={inputHandler} value={quotesForm.last_name} />
                                                <div className="invalid-feedback">{validationError.last_nameError}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="company_name">Company name<span className="req-star">*</span></label>
                                                <input className={validationError.company_nameError ? 'form-control is-invalid' : 'form-control'} id="company_name" name="company_name" placeholder="Enter company name" type="text" onChange={inputHandler} value={quotesForm.company_name} />
                                                <div className="invalid-feedback">{validationError.company_nameError}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="email">Email<span className="req-star">*</span></label>
                                                <input className={validationError.emailError ? 'form-control is-invalid' : 'form-control'} id="email" name="email" placeholder="Enter email address" type="email" onChange={inputHandler} value={quotesForm.email} />
                                                <div className="invalid-feedback">{validationError.emailError}</div>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="phone">Phone<span className="req-star">*</span></label>
                                                <input className={validationError.phoneError ? 'form-control is-invalid' : 'form-control'} id="phone" name="phone" placeholder="Enter phone number" type="text" onChange={inputHandler} onKeyPress={handleKeyPress} maxLength="10" value={quotesForm.phone} />
                                                <div className="invalid-feedback">{validationError.phoneError}</div>
                                            </div>
                                            
                                            <div className="col-md-4">
											<label className="form-label" htmlFor="address">Address<span className="req-star">*</span></label>
											<input className={validationError.addressError ? 'form-control is-invalid' : 'form-control'} id="address" name="address" placeholder="Enter address" type="text" onChange={inputHandler} value={quotesForm.address} />
											<div className="invalid-feedback">{validationError.phoneError}</div>
											</div>

											<div className="col-md-3">
											<label className="form-label" htmlFor="suburb">Suburb<span className="req-star">*</span></label>
											<input className={validationError.suburbError ? 'form-control is-invalid' : 'form-control'} id="suburb" name="suburb" placeholder="Enter suburb" type="text" onChange={(e) => SearchSuburb(e.target.value)} autoComplete="off" value={suburb} />
											<span className="invalid-feedback">{validationError.suburbError}</span>
											{SuburbsearchResults.length > 0 ? (
											<ul className="suburbList">
											{SuburbsearchResults.map((row) => (
											<li key={row.id} onClick={() => handleSelectSuburb(row)}>
											{row.rowlocation} 
											</li>
											))}
											</ul>
											) : null}
											</div>
											<div className="col-md-2">
											<label className="form-label" htmlFor="postcode">Postcode<span className="req-star">*</span></label>
											<input className={validationError.postcodeError ? 'form-control is-invalid' : 'form-control'} id="postcode" name="postcode" value={postcode} placeholder="Enter postcode" type="text" readOnly disabled />
											<div className="invalid-feedback">{validationError.postcodeError}</div>
											</div> 
											<div className="col-md-3">
											<label className="form-label" htmlFor="state">State<span className="req-star">*</span></label>
											<select className={validationError.stateError ? 'form-control is-invalid' : 'form-control'} aria-label="select example" id="state" name="state" onChange={inputHandler} value={quotesForm.state} disabled>
											<option value="">Select state</option>
											<option value="ACT">Australian Capital Territory</option>
											<option value="NSW">New South Wales</option>
											<option value="NT">Northern Territory</option>
											<option value="QLD">Queensland</option>
											<option value="SA">South Australia</option>
											<option value="TSA">Tasmania</option>
											<option value="VIC">Victoria</option>
											<option value="WA">Western Australia</option>					
											</select>
											<div className="invalid-feedback">{validationError.stateError}</div>
											</div> 
                                            
                                           
                                            <div className="col-md-4">
                                                <label className="form-label" htmlFor="quotesProducts">Search product <span className="req-star">*</span></label>
                                                <input
                                                    className={validationError.quotesProductsError ? 'form-control is-invalid' : 'form-control'}
                                                    name="quotesProducts"
                                                    placeholder="Search product"
                                                    type="text"
                                                    onChange={(e) => searchtempproduct(e.target.value)}
                                                    autoComplete="off"
                                                />
                                                {searchProduct.length > 0 && (
                                                    <ul className="suburbList">
                                                        {searchProduct.map((row) => (
                                                            <li key={row.id} onClick={() => handleProductSelect(row)}>
                                                                {row.hobson_part}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                <div className="invalid-feedback">{validationError.quotesProductsError}</div>
                                            </div>

                                            <div className="col-md-4">
                                            <label className="form-label">Required Shipping </label>

                                            <div className="add-update-form-check form-check form-switch">
                                                    <input
                                                    className="form-check-input"
                                                    id="required_shipping"
                                                    name="required_shipping"
                                                    type="checkbox"
                                                    checked={quotesForm.required_shipping}
                                                    onChange={() => handleincludeshipping(quotesForm.required_shipping === 1 ? 0 : 1)}
                                                    
                                                    />
                                            </div>
                                            </div>

                                            {quotesForm.quotesProducts.length > 0 && (
                                                <div className="row mt-4" id="tempproducts">
                                                 <div className="text-start"><span>Hobson Products</span></div>
                                                    <table className="table mb-0">
                                                        <thead className="table-light fw-semibold">
                                                            <tr className="align-middle table-heading">
                                                                <th>PART</th>
                                                                <th >Description</th>
                                                                <th>Custom Price</th>
                                                                <th>Price</th>
                                                                <th style={{textAlign:"center"}}>Quantity</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {quotesForm.quotesProducts.map((row, index) => (
                                                                <tr key={index}>
                                                                    <td>{row.hobson_part}</td>
                                                                    <td>{row.description}</td>
                                                                    <td>
																		<input 
																			type="text" 
																			className="form-control" 
																			value={row.custom_price} 
																			onChange={(e) => handlePriceChange(e, row, index)}
																			style={{height:"25px",width:"80px"}}
																			onKeyPress={handlePriceKeyPress}
																		/>
																	</td>
																	<td>{row.pPrice}</td>
                                                                    <td style={{textAlign:"center"}}>
																<div className="quntity-box d-flex gap-3 items-center ">
																	<div className="value-button mt-1 csr-ptr" id="decrease" onClick={(e)=>handleQuantityChangeManual(e,row,'dec',index)}  >-</div>
																	<input type="text" className="form-control" style={{height:"25px",width:"80px",textAlign:"center"}} value={row.sell_quantity_minimum || ''}  onChange={(e) => handleProductQuantityChange(e, index)} onBlur={(e)=>updateProductQuantity(e,row,index)} onKeyDown={(e) => updateProductQuantityOnEnter(e,row,index)} />
																	<div className="csr-ptr mt-1 " id="increase" onClick={(e)=>handleQuantityChangeManual(e,row,'inc',index)}  >+</div>
																</div>
																</td>
                                                                    <td>
                                                                        <span className="csr-ptr" onClick={() => removetemproduct(index)}>x</span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                            
                                            {quotesForm.custom_products.length>0 && (
                                                <div className="row mt-4" id="tempcustomproducts">
                                                
                                                <div className="text-start"><span>Custom Products</span></div>
                                                
                                                
                                                <label></label>
                                                    <table className="table mb-0">
                                                        <thead className="table-light fw-semibold">
                                                            <tr className="align-middle table-heading">
                                                                <th>PART</th>
                                                                <th >Description</th>
                                                                <th>Custom Price</th>
                                                                <th style={{textAlign:"center"}}>Quantity</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
														{quotesForm.custom_products.map((row, index) => (
															<tr key={index}>
																<td>
																	<input 
																		type="text" 
																		className={`form-control ${validationError[`customProduct_${index}_sku`] ? 'is-invalid' : ''}`} 
																		name="product_sku" 
																		value={row.product_sku} 
																		onChange={(e) => handleInputChangeCustomProduct(e, row)}
																		style={{height:"25px",width:"90%"}}
																	/>
																</td>
																<td>
																	<input 
																		type="text" 
																		className={`form-control ${validationError[`customProduct_${index}_description`] ? 'is-invalid' : ''}`} 
																		name="product_description" 
																		value={row.product_description} 
																		onChange={(e) => handleInputChangeCustomProduct(e, row)}
																		style={{height:"25px",width:"90%"}}
																	/>
																</td>
																<td>
																	<input 
																		type="text" 
																		className={`form-control ${validationError[`customProduct_${index}_customPrice`] ? 'is-invalid' : ''}`} 
																		name="custom_price" 
																		value={row.custom_price} 
																		onChange={(e) => handleInputChangeCustomProduct(e, row)}
																		style={{height:"25px",width:"80px"}}
																		onKeyPress={handlePriceKeyPress}
																	/>
																</td>
																<td style={{textAlign:"center"}}>
																	<div className="quntity-box d-flex gap-3 items-center">
																		<div 
																			className="value-button mt-1 csr-ptr" 
																			id="decrease" 
																			onClick={(e) => handleQuantityChangeManualCustom(e, row, 'dec')}
																		>
																			-
																		</div>
																		<input 
																			type="text" 
																			className={`form-control ${validationError[`customProduct_${index}_quantity`] ? 'is-invalid' : ''}`} 
																			name="product_quantity" 
																			style={{height:"25px",width:"80px",textAlign:"center"}} 
																			value={row.product_quantity}  
																			onChange={(e) => handleInputChangeCustomProduct(e, row)} 
																			onKeyPress={handlePriceKeyPress}
																		/>
																		<div 
																			className="csr-ptr mt-1" 
																			id="increase" 
																			onClick={(e) => handleQuantityChangeManualCustom(e, row, 'inc')}
																		>
																			+
																		</div>
																	</div>
																</td>
																<td>
																	<span 
																		className="csr-ptr" 
																		onClick={() => CartRemoveCustomProduct(row.product_id)}
																	>
																		x
																	</span>
																</td>
															</tr>
														))}
													</tbody>

                                                    </table>
                                                </div>
                                            )}
                                            <div className="text-end">
													<button 
														className="btn btn-primary" 
														type="button"
														onClick={() => handleCustomProductSelect()}>+ Custom Products</button>
										    </div>				
                                            
                                            {quotesForm.quotesProducts.length > 0 && (
												<div className="col-12">
													<div className="row">
														<div className="col-md-5 offset-md-7">
															<div className="card mb-3">
																<div className="card-body">
																	<div className={`row align-items-center ${quotesForm.required_shipping === 0 ? 'd-none' : ''}`}>
																		<div className="col-md-5">
																			<button 
																				type="button" 
																				className="btn btn-primary" 
																				onClick={calculateShipping}
																				disabled={shiploader === 1}
																			>
																				{shiploader === 1 ? 'Calculating...' : 'Calculate Shipping'}
																			</button>
																		</div>
																		<div className="col-md-7">
																			<div className="input-group">
																				<span className="input-group-text">Shipping Cost ($)</span>
																				<input 
																					type="text" 
																					className="form-control" 
																					value={quotesForm.shipping} 
																					readOnly 
																				/>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div className="text-end">
																<button 
																	className="btn btn-primary" 
																	type="submit"
																	disabled={((!quotesForm.shipping || quotesForm.shipping==='0.00') && quotesForm.required_shipping===1) || spinloader === 1}
																>
																	{spinloader === 1 ? 'Creating...' : 'Create Quote'}
																</button>
															</div>
														</div>
													</div>
												</div>
											)}                                            
                                           
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Addquotes;
